<template>
    <div class="container">
        <img src="../../assets/img/moose_C.jpg" alt="Responsive Image" class="image" id="responsiveImage">
        <div style="position: absolute;left: 50%;transform: translateX(-50%);display: flex;gap: 60px;bottom: 20%;">

            <el-button  @click="clearBtn"  class="custom-button" >
                <div style="display: flex;flex-direction: column;justify-content: center;line-height: 15px;">
                    <span style="padding-top: 4px;color: rgba(0, 0, 0, 0.65);">洗护</span>
                    <span style="padding-bottom: 2px;color:  rgba(0, 0, 0, 0.65);">Laundry Service</span>
                </div>
            </el-button>

            <el-button  @click="queryBtn"    class="custom-button">
                <div style="display: flex;flex-direction: column;justify-content: center;line-height: 15px;">
                    <span style="padding-top: 4px;color:  rgba(0, 0, 0, 0.65);">查询</span>
                    <span style="padding-bottom: 2px;color:  rgba(0, 0, 0, 0.65);">Search</span>
                </div>
            </el-button>


        </div>

    </div>
</template>

<script>
    export default {
        mounted() {
            this.adjustImageSize();  // 在组件挂载后调用调整图片的函数
            window.addEventListener("resize", this.adjustImageSize);
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.adjustImageSize);  // 清理事件监听
        },
        methods: {
            adjustImageSize() {
                const image = document.getElementById("responsiveImage");
                if (!image) return;  // 防止 null 错误

                if (window.innerWidth <= 768) {
                    // 在手机端，图片高度和宽度都占满屏幕
                    image.style.width = "100vw";
                    image.style.height = "100vh";
                    image.style.objectFit = "cover";
                } else {
                    // 在桌面端，保持原有的比例
                    image.style.width = "auto";
                    image.style.height = "100%";
                    image.style.objectFit = "contain";
                }
            },
            clearBtn() {
                this.$router.push({
                    path: "/moose/customerInfo",
                });
            },

            queryBtn() {
                this.$router.push({
                    path: "/moose/washing",
                });
            },
        }
    };
</script>

<style scoped>
    .custom-button {
        width: 100px;
        height: 40px;
        padding: 0px 0px;
        border: 1px solid #dae3f3;
        background-color: #dae3f3;
    }

    .custom-button:hover {
        /*background-color: #ffffff; !* 鼠标悬停时背景色 *!*/
        color: #56b8e1; /* 悬停时字体颜色 */
        border: 1px solid #56b8e1;
    }

    .custom-button:hover  span {
        color: #56b8e1 !important; /* 悬停时子元素字体颜色 */
    }

    .container {
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
    }

    .image {
        max-height: 100%;
        width: auto;
        object-fit: contain;
    }
</style>
